import { forwardRef } from 'react';
import { Icon } from '../icon';
import { TextEllipsis } from '../text-ellipsis';
import * as Styled from './styles';
import type { ChipContentProps as Props } from './types';

export const ChipContent = forwardRef<HTMLDivElement, Props>(
  ({ endIcon, ...other }: Props, ref) => {
    return (
      <Styled.ContentWrapper ref={ref} className={'MuiChip-labelContent'}>
        <TextEllipsis
          variant={other.size === 'small' ? 'body5' : 'body4'}
          color={other.color}
        >
          {other.label && other.label}
        </TextEllipsis>
        {endIcon && (
          <Icon
            className="MuiChip-endIcon"
            name={endIcon}
            // size={iconSize}
            // sxx={{ minWidth: iconSize }}
          />
        )}
      </Styled.ContentWrapper>
    );
  }
);

ChipContent.displayName = 'ChipContent';
